var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.845 4.35a2.65 2.65 0 115.3 0 2.65 2.65 0 01-5.3 0zM6.495 0a4.35 4.35 0 100 8.7 4.35 4.35 0 000-8.7zm.163 10.434a6.537 6.537 0 00-3.846 1.241 6.06 6.06 0 00-2.28 3.245.85.85 0 101.636.462c.26-.92.835-1.742 1.645-2.333a4.838 4.838 0 012.845-.915c1.034 0 2.034.324 2.845.915a4.361 4.361 0 011.645 2.333.85.85 0 101.636-.462 6.06 6.06 0 00-2.28-3.245 6.537 6.537 0 00-3.846-1.241zm8.243-5.217c.47 0 .85.38.85.85v1.758h1.898a.85.85 0 010 1.7H15.75v1.759a.85.85 0 11-1.7 0V9.525h-1.898a.85.85 0 010-1.7h1.898V6.067c0-.47.38-.85.85-.85z",
    fill: "currentColor"
  })));
}
export default SvgInvite;